'use strict';

// Constants
var ATTRIBUTES = {
    CLASSES: {
        AVAILABILITY_MSG: '.availability-msg',
        ADD_TO_CART_GLOBAl: '.add-to-cart-global',
        PRODUCT_AVAILABILITY: '.product-availability'
    },
    DATA: {
        AVAILABLE: 'available',
        DATA_READY_TO_ORDER: 'data-readytoorder',
        DATA_AVAILABLE: 'data-available',
        READY_TO_ORDER: 'ready-to-order'
    }
};

// Importing the base module from a relative path.
var base = require('./base');

// Importing the 'detail' module
var detail = require('base/product/detail');

// Importing the 'addToCart' module to enable or disable the add to cart button
var addToCart = require('./addToCart');

// Overriding the 'availability' function.
detail.availability = base.availability;

// Overriding the 'colorAttribute' function.
detail.colorAttribute = base.colorAttribute;

// Overriding the 'selectAttribute' function.
detail.selectAttribute = base.selectAttribute;

// Overriding the 'updateAddToCart' function.
detail.updateAddToCart = $('body').on('product:updateAddToCart', function (e, response) {
    // Update Add to Cart button availability data attributes
    $('button.add-to-cart', response.$productContainer).attr('data-readytoorder', response.product.readyToOrder);

    $('button.add-to-cart', response.$productContainer).attr('data-available', response.product.available);

    var enable = $('.product-availability')
        .toArray()
        .every(function (item) {
            return $(item).data('available') && $(item).data('ready-to-order');
        });

    // Run validations to enable or disable add to cart button
    addToCart.enableAddToCartButton();

    module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
});

/**
 * Updates the availability message and add to cart button for the given Product
 */
detail.updateAvailability = function () {
    $('body').on('product:updateAvailability', function (e, response) {
        $('div.availability', response.$productContainer)
            .data(ATTRIBUTES.DATA.READY_TO_ORDER, response.product.readyToOrder)
            .data(ATTRIBUTES.DATA.AVAILABLE, response.product.available);

        $(ATTRIBUTES.CLASSES.AVAILABILITY_MSG, response.$productContainer).empty().html(response.message);

        if ($(ATTRIBUTES.CLASSES.ADD_TO_CART_GLOBAl).length) {
            var allAvailable = $(ATTRIBUTES.CLASSES.PRODUCT_AVAILABILITY)
                .toArray()
                .every(function (item) {
                    return $(item).data(ATTRIBUTES.DATA.AVAILABLE);
                });

            var allReady = $(ATTRIBUTES.CLASSES.PRODUCT_AVAILABILITY)
                .toArray()
                .every(function (item) {
                    return $(item).data(ATTRIBUTES.DATA.READY_TO_ORDER);
                });

            $(ATTRIBUTES.CLASSES.ADD_TO_CART_GLOBAl)
                .attr(ATTRIBUTES.DATA.DATA_READY_TO_ORDER, allReady)
                .attr(ATTRIBUTES.DATA.AVAILABLE, allAvailable);

            $('.global-availability .availability-msg')
                .empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        }
    });
};

// Overriding the 'updateAttributesAndDetails' function.
detail.updateAttributesAndDetails = function () {
    $('body').on('product:statusUpdate', function (e, data) {
        var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

        /**
         * Safely decodes a URI component, handling malformed input and HTML-encoded percent signs.
         *
         * Attempts to decode the given value using `decodeURIComponent`. If decoding fails due to malformed input,
         * it tries to clean up the value and decode again. As a last resort, it replaces common HTML entities.
         *
         * @param {string|null|undefined} value - The value to decode.
         * @returns {string} The decoded string, or a best-effort fallback if decoding fails.
         */
        function safeDecodeURIComponent(value) {
            if (value === undefined || value === null) {
                return '';
            }
            try {
                // Replace HTML-encoded percent back to % for proper decoding
                var normalized = String(value).replace(/&#37;/g, '%');
                return decodeURIComponent(normalized);
            } catch (err) {
                // If decodeURIComponent fails (malformed URI), fall back to a best-effort
                // Try to unescape percent sequences conservatively by replacing stray percent
                // signs and removing invalid sequences.
                try {
                    var cleaned = String(value).replace(/%(?![0-9A-Fa-f]{2})/g, '%25');
                    cleaned = cleaned.replace(/&#37;/g, '%');
                    return decodeURIComponent(cleaned);
                } catch (err2) {
                    return String(value).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
                }
            }
        }

        $productContainer.find('.description-and-detail .product-attributes').empty().html(safeDecodeURIComponent(data.attributesHtml));

        if (data.shortDescription) {
            $productContainer.find('.description-and-detail .description').removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .description .content').empty().html(safeDecodeURIComponent(data.shortDescription));
        } else {
            $productContainer.find('.description-and-detail .description').addClass('hidden-xl-down');
        }

        if (data.longDescription) {
            $productContainer.find('.description-and-detail .details').removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .details .content').empty().html(safeDecodeURIComponent(data.longDescription));
        } else {
            $productContainer.find('.description-and-detail .details').addClass('hidden-xl-down');
        }
    });
};

/**
 * Apply the result of a Product-Variation refresh to the PDP container.
 * Handles both directions: restricting when basket fills up and restoring when basket is reduced.
 * Only updates the quantity dropdown, availability message, and add-to-cart button state, without a full PDP refresh,
 * to preserve the user's current selections and scroll position.
 * @param {jQuery} $productContainer - The jQuery element of the PDP container to update.
 * @param {Object} response - The AJAX response from the Product-Variation endpoint, containing updated product data.
 */
function applyPdpQuantityRefresh($productContainer, response) {
    if (!response.product) return;

    var quantities = response.product.quantities || [];
    var $quantitySelect = $productContainer.find('.quantity-select');

    if (!quantities.length) {
        $productContainer.find('.attribute.quantity, .simple-quantity').hide();
        $productContainer.find('.select2-container').hide();
        $productContainer.find('button.add-to-cart')
            .prop('disabled', true)
            .attr('data-available', 'false');
        var $avail = $productContainer.find('.product-availability');
        $avail.data('available', false).attr('data-available', 'false');
        var notAvailableMsg = $avail.data('not-available-msg') || 'Sem stock';
        $productContainer.find('.availability-msg').html('<div>' + notAvailableMsg + '</div>');
    } else {
        var alreadyVisible = $productContainer.find('.attribute.quantity, .simple-quantity').is(':visible');

        $quantitySelect.empty();
        quantities.forEach(function (q) {
            $('<option>', { value: q.value, selected: q.selected })
                .attr('data-url', q.url)
                .text(q.value)
                .appendTo($quantitySelect);
        });

        if (!alreadyVisible) {
            // Transitioning from unavailable → available: rebuild select2 from scratch
            if ($quantitySelect.hasClass('select2-hidden-accessible')) {
                $quantitySelect.select2('destroy');
                $quantitySelect.removeAttr('data-is-select-loaded');
            }
            if (typeof $.initCustomSelects === 'function') {
                $.initCustomSelects();
            }
        } else if ($quantitySelect.hasClass('select2-hidden-accessible')) {
            // Already visible: just refresh the select2 display without rebuilding
            $quantitySelect.trigger('change.select2');
        }

        $productContainer.find('.attribute.quantity, .simple-quantity').show();

        $productContainer.find('button.add-to-cart').attr('data-available', 'true');
        var $availRestore = $productContainer.find('.product-availability');
        $availRestore.data('available', true).attr('data-available', 'true');

        if (response.product.availability && response.product.availability.messages) {
            var msgHtml = response.product.availability.messages
                .map(function (m) { return '<div>' + m + '</div>'; })
                .join('');
            $productContainer.find('.availability-msg').html(msgHtml);
        }

        // Re-evaluate button state (consent checkbox may still block it)
        addToCart.enableAddToCartButton();
    }
}

/**
 * Get the Product-Variation refresh URL for the PDP container.
 * Falls back to data-variation-url when the dropdown is hidden (no options in select).
 * Returns null if no URL is found, which signals that the refresh handlers to skip the AJAX call.
 * @param {jQuery} $productContainer - The jQuery element of the PDP container to get the URL for.
 * @returns {string|null} The URL to use for refreshing the PDP via Product-Variation, or null if not available.
 */
function getPdpRefreshUrl($productContainer) {
    var urlFromOption = $productContainer.find('.quantity-select option:first').data('url');
    if (urlFromOption) return urlFromOption;
    return $productContainer.data('variation-url') || null;
}

/**
 * After a successful add-to-cart, refresh the quantity dropdown via Product-Variation
 * so it reflects the remaining web-allocated quantity (allocation - qty now in basket).
 * Targets only the PDP container, not the quickview modal (which closes after add-to-cart).
 */
detail.refreshQuantityAfterAddToCart = function () {
    $('body').on('product:afterAddToCart', function (e, data) {
        if (data.error) return;

        var $productContainer = $('.product-detail:not(.product-set-detail):not(.product-quickview)');
        if (!$productContainer.length) return;

        var refreshUrl = getPdpRefreshUrl($productContainer);
        if (!refreshUrl) return;

        $.ajax({
            url: refreshUrl,
            method: 'GET',
            success: function (response) { applyPdpQuantityRefresh($productContainer, response); }
        });
    });
};

/**
 * When an item is removed or updated in the cart/minicart, refresh the PDP so quantity
 * constraints and availability stay consistent without a page reload.
 */
detail.refreshQuantityOnCartUpdate = function () {
    $('body').on('cart:update', function () {
        var $productContainer = $('.product-detail:not(.product-set-detail):not(.product-quickview)');
        if (!$productContainer.length) return;

        var refreshUrl = getPdpRefreshUrl($productContainer);
        if (!refreshUrl) return;

        $.ajax({
            url: refreshUrl,
            method: 'GET',
            success: function (response) { applyPdpQuantityRefresh($productContainer, response); }
        });
    });
};

module.exports = detail;
